import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import active_on from './../images/icons/active_on.png';
import active_off from './../images/icons/active_off.png';


export default class MessagesFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      addNew: false,
      filtersCounter: 0,
      allowEdit: false,
      // filters
      filters_isActive: 1,
      dateFrom: '',
      dateTo: '',
      toHQ: 'ANY',
      toOwn: 'ANY',
      toF: 'ANY',
      toClients: 'ANY',
    };
    this.queryData = {};
    this.searchKeyword = React.createRef();
  }

  componentDidMount() {
    if (this.props.allowEdit === true) this.setState({ allowEdit: true });
    // Default: show active
    this.queryData.isActive = 1;
    this.apply();
  }

  // --- helpers ---
  ymdToDmy = (s) => {
    if (!s || s.length < 10) return '';
    const [y, m, d] = s.split('-');
    if (!y || !m || !d) return '';
    return `${d}-${m}-${y}`;
  };
  endOfDayDmy = (s) => {
    const dmy = this.ymdToDmy(s);
    return dmy ? `${dmy} 23:59:59` : '';
  };

  // count only real user filters (ignore compat keys)
  computeCount = () => {
    const present = (k) => this.queryData[k] !== undefined && this.queryData[k] !== '';
    return [
      'isActive', 'dateFrom', 'dateTo',
      'sendToHQ', 'sendToAllLocationsOwn', 'sendToAllLocationsF', 'sendToAllClients',
      'keyword'
    ].filter(present).length;
  };

  apply = () => {
    this.setState({ filtersCounter: this.computeCount() });
    if (typeof this.props.applyFilters === 'function') {
      this.props.applyFilters(this.queryData);
    }
  };

  searchKey = (e) => {
    const keyword = (e.target.value || '').trim();
    if (keyword.length > 2) {
      // unified keyword filter; keep backward-compat if your API still reads the old fields
      this.queryData.keyword = keyword;
      this.queryData.subjectLike = keyword; // backward compat
      this.queryData.messageLike = keyword; // backward compat
    } else {
      delete this.queryData.keyword;
      delete this.queryData.subjectLike;
      delete this.queryData.messageLike;
    }
    this.apply();
  };

  toggleActive = () => {
    const newVal = this.state.filters_isActive ? 0 : 1;
    this.setState({ filters_isActive: newVal });
    if (newVal === 1) this.queryData.isActive = 1; else delete this.queryData.isActive;
    this.apply();
  };

  onDateFromChange = (e) => {
    const ymd = e.target.value;
    this.setState({ dateFrom: ymd });
    const dmyStart = this.ymdToDmy(ymd);
    if (dmyStart) this.queryData.dateFrom = dmyStart; else delete this.queryData.dateFrom;
    this.apply();
  };
  onDateToChange = (e) => {
    const ymd = e.target.value;
    this.setState({ dateTo: ymd });
    const dmyEnd = this.endOfDayDmy(ymd);
    if (dmyEnd) this.queryData.dateTo = dmyEnd; else delete this.queryData.dateTo;
    this.apply();
  };

  // audience toggles (ANY/YES only; filter only if YES)
  onTriHQ = () => {
    const next = this.state.toHQ === 'YES' ? 'ANY' : 'YES';
    this.setState({ toHQ: next });
    if (next === 'YES') this.queryData.sendToHQ = 1; else delete this.queryData.sendToHQ;
    this.apply();
  };
  onTriOwn = () => {
    const next = this.state.toOwn === 'YES' ? 'ANY' : 'YES';
    this.setState({ toOwn: next });
    if (next === 'YES') this.queryData.sendToAllLocationsOwn = 1; else delete this.queryData.sendToAllLocationsOwn;
    this.apply();
  };
  onTriF = () => {
    const next = this.state.toF === 'YES' ? 'ANY' : 'YES';
    this.setState({ toF: next });
    if (next === 'YES') this.queryData.sendToAllLocationsF = 1; else delete this.queryData.sendToAllLocationsF;
    this.apply();
  };
  onTriClients = () => {
    const next = this.state.toClients === 'YES' ? 'ANY' : 'YES';
    this.setState({ toClients: next });
    if (next === 'YES') this.queryData.sendToAllClients = 1; else delete this.queryData.sendToAllClients;
    this.apply();
  };

  resetFilters = () => {
    this.queryData = {};
    if (this.searchKeyword.current) this.searchKeyword.current.value = '';
    this.setState({
      filters_isActive: 0,
      filtersCounter: 0,
      dateFrom: '',
      dateTo: '',
      toHQ: 'ANY',
      toOwn: 'ANY',
      toF: 'ANY',
      toClients: 'ANY'
    });
    if (typeof this.props.applyFilters === 'function') {
      this.props.applyFilters(this.queryData);
    }
  };

  handleExpandClick = () => { this.setState((s) => ({ expanded: !s.expanded })); };
  toggleAdd = () => { if (!this.state.allowEdit) return; this.setState((s) => ({ addNew: !s.addNew })); if (this.props.toggleAdd) this.props.toggleAdd(); };

  renderAudienceToggle(label, stateKey, onClick){
    const selected = this.state[stateKey] === 'YES';
    const tip = selected
      ? `${label}: filtering to messages that include ${label}`
      : `${label}: include ${label} or not (no filter)`;
    return (
      <Tooltip title={tip}>
        <IconButton aria-label={label} onClick={onClick}>
          <Avatar
            sx={{
              width:24, height:24,
              bgcolor: selected ? '#4caf50' : '#273442',
              color: selected ? '#fff' : '#e3e3e5',
              fontSize: 12
            }}
          >
            {label.substring(0,3)}
          </Avatar>
        </IconButton>
      </Tooltip>
    );
  }

  render() {
    return (
      <Card sx={{ borderRadius: '16px', m: 1, backgroundColor: '#214a80' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          {/* Left controls: add + active */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title={this.state.addNew ? 'Hide New Message form' : 'Show New Message form'}>
              <IconButton aria-label="Add Message" onClick={this.toggleAdd}>
                <Avatar alt="Add Message" sx={{ width: 24, height: 24, color: '#273442' }}>
                  {this.state.addNew ? <FaMinusCircle /> : <FaPlusCircle />}
                </Avatar>
              </IconButton>
            </Tooltip>

            <Tooltip title={this.state.filters_isActive ? 'Filtering Active messages only' : 'Include inactive messages'}>
              <IconButton aria-label="Active" onClick={this.toggleActive}>
                <Avatar alt="Active" src={this.state.filters_isActive ? active_on : active_off} sx={{ width: 24, height: 24 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {/* audience toggles (ANY/YES only) */}
          <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
            {/* {this.renderAudienceToggle('HQ','toHQ',this.onTriHQ)} */}
            {this.renderAudienceToggle('Locations','toOwn',this.onTriOwn)}
            {/* {this.renderAudienceToggle('Franchise','toF',this.onTriF)} */}
            {this.renderAudienceToggle('Clients','toClients',this.onTriClients)}
          </Box>

          {/* Simple date range */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Tooltip title="Start of the period (optional)">
              <TextField
                id="date-from"
                label="From"
                type="date"
                variant="standard"
                value={this.state.dateFrom}
                onChange={this.onDateFromChange}
                sx={{ color: '#e3e3e5' }}
                InputLabelProps={{ shrink: true, sx: { color: '#e3e3e5' } }}
                InputProps={{ sx: { color: '#e3e3e5' } }}
              />
            </Tooltip>
            <Tooltip title="End of the period (optional)">
              <TextField
                id="date-to"
                label="To"
                type="date"
                variant="standard"
                value={this.state.dateTo}
                onChange={this.onDateToChange}
                sx={{ color: '#e3e3e5' }}
                InputLabelProps={{ shrink: true, sx: { color: '#e3e3e5' } }}
                InputProps={{ sx: { color: '#e3e3e5' } }}
              />
            </Tooltip>
          </Box>

          {/* Keyword */}
          <Tooltip title="Keyword search across Subject and Message (min 3 characters)">
            <TextField
              id="search-subject"
              inputRef={this.searchKeyword}
              label="Subject / message contains"
              variant="standard"
              onChange={this.searchKey}
              InputLabelProps={{ sx: { color: '#e3e3e5' } }}
              inputProps={{ sx: { color: '#e3e3e5' } }}
              sx={{ width: 240, color: '#e3e3e5', marginLeft: '32px' }}
            />
          </Tooltip>

          {/* Filters counter + clear */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ color: '#e3e3e5' }}>
              Messages: {this.props.counter}
            </Typography>
            <Typography variant="body2" sx={{ color: '#e3e3e5' }}>
              Filters: {this.state.filtersCounter}
            </Typography>
            {this.state.filtersCounter > 0 && (
              <Tooltip title="Clear all filters">
                <IconButton aria-label="Clear filters" onClick={this.resetFilters}>
                  <Avatar alt="Clear" sx={{ width: 18, height: 18, color: '#99302e' }}>
                    <HighlightOffIcon fontSize="small" />
                  </Avatar>
                </IconButton>
              </Tooltip>
            )}
          </Box>

        </Box>

      </Card>
    );
  }
}